// extracted by mini-css-extract-plugin
export default {"checkboxround":"RoundCheckbox_checkboxround__z3Rqr","container":"RoundCheckbox_container__Ugy0o","labelStyle":"RoundCheckbox_labelStyle__Iv-xA"};